import { useMemo } from 'react';

const UniqueId = (prefix = 'uid') => {
  return useMemo(() => {
    return (id) => `${prefix}-${id}-${Math.random().toString(36).substring(2, 9)}`;
  }, [prefix]);
};

export default UniqueId;